<template>
  <div class="toggle-tutorial">
    <v-icon style="font-size: 1em">help</v-icon>
    <a @click="toggleTutorial">
      <template v-if="disabled">Show tutorials</template>
      <template v-else>Hide Tutorials</template>
    </a>
  </div>
</template>

<script>
  export default {
    name:'TutorialToggle',
    props: {
      name: {
        type: String,
        required: true
      },
      disabled:{
        type: Boolean,
        default: false
      }
    },
    methods: {
      toggleTutorial() {this.$events.emit('toggleTutorial.' + this.name) }
    }
  }
</script>

<style scoped lang="scss">

  .toggle-tutorial {
    display: inline-block;
    color: #636363;

    a {
      text-decoration: none;
      color: inherit;
      &:hover {
        text-decoration: underline;
      }
    }
    .icon {
      position: relative;
      top: -2px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/elements/TutorialToggle.vue